import { useCallback, useEffect, useState } from 'react';

interface IStorageItem {
  key: string;
  newValue: string;
  oldValue: string;
}

export const useStorageListener = (key: string) => {
  const [value, setValue] = useState<IStorageItem>(null);

  const onChangeStorage = useCallback(
    (event: any) => {
      if (event?.detail?.key === key) {
        setValue(event?.detail);
      }
    },
    [key]
  );

  useEffect(() => {
    window.addEventListener('localstorage', onChangeStorage, false);

    return () => {
      window.removeEventListener('localstorage', onChangeStorage);
    };
  }, [onChangeStorage]);

  return value;
};
